import * as React from 'react';

import { RECIPIENT_TYPES } from 'reducers/roleBasedMessagingSearch';
import CenteredLoadingIndicator from 'components/CenteredLoadingIndicator';
import TargetByStudentIdNull from './TargetByStudentIdNull';
import TargetByStudentIdSelectPage from './TargetByStudentIdSelectPage';
import TargetByStudentIdUploadPage from './TargetByStudentIdUploadPage';
import { ComposerOrganization } from 'types/typescript/messagingTypes';

import type { TargetByStudentIdPages } from './SelectRecipientPanel';

type Props = {
  onContinue: () => void;
  onPageChange: (page: TargetByStudentIdPages) => void;
  // @ts-expect-error ts-migrate(2304) FIXME: Cannot find name 'StudentIdListRecipient'.
  studentIdListRecipientInSelection: StudentIdListRecipient | undefined | null;
  // graphql data from container
  loading: boolean;
  organizations: Partial<ComposerOrganization>[] | undefined | null;
  // redux dispatchers from container
  // @ts-expect-error ts-migrate(2304) FIXME: Cannot find name 'StudentIdListRecipient'.
  selectStudentIdListRecipient: (recipient: StudentIdListRecipient) => void;
  clearSelection: () => any;
};

type State = {
  showNullState: boolean;
  studentIdListUuid: string | undefined | null;
  csvName: string | undefined | null;
  selectedOrganizationUuid: string;
};

class TargetByStudentIdPanel extends React.Component<Props, State> {
  constructor(props: Props) {
    super(props);
    this.state = {
      showNullState: false,
      studentIdListUuid:
        props.studentIdListRecipientInSelection && props.studentIdListRecipientInSelection.id,
      csvName:
        props.studentIdListRecipientInSelection && props.studentIdListRecipientInSelection.csvName,
      selectedOrganizationUuid: props.studentIdListRecipientInSelection
        ? props.studentIdListRecipientInSelection.orgUuid
        : '',
    };
  }

  componentDidMount() {
    const { organizations, studentIdListRecipientInSelection } = this.props;
    if (
      organizations &&
      !this.organizationsHaveEnoughStudentIds(organizations) &&
      !studentIdListRecipientInSelection
    ) {
      this.showNullState();
    }
  }

  componentDidUpdate(prevProps: Props) {
    if (
      !prevProps.organizations &&
      this.props.organizations &&
      !this.organizationsHaveEnoughStudentIds(this.props.organizations) &&
      !this.props.studentIdListRecipientInSelection
    ) {
      this.showNullState();
    }
  }

  showNullState = () => {
    this.setState({ showNullState: true });
  };

  hideNullState = () => {
    this.setState({ showNullState: false });
  };

  organizationsHaveEnoughStudentIds = (organizations: Partial<ComposerOrganization>[]) => {
    // JMR: temporary fix Sep 14 2023
    // we've removed the studentIdPercentage field from the query that populates this because
    // retrieving it so slow for large districts that it was causing the entire query that loads the composer to fail
    // we need to refactor something to make it more efficient and/or lazy load that value only when it's needed
    return organizations.length > 0;
    // return organizations.length
    //   ? organizations.some((organization) => organization.studentIdPercentage > 0.5)
    //   : false;
  };

  addListToSelection = (studentIdList: any, csvName: string) => {
    this.props.selectStudentIdListRecipient({
      type: RECIPIENT_TYPES.STUDENT_ID_LIST_RECIPIENT,
      id: studentIdList.uuid,
      csvName,
      fileUuid: studentIdList.fileUuid,
      includeParents: studentIdList.includeParents,
      includeStudents: studentIdList.includeStudents,
      orgUuid: studentIdList.organizationUuid,
      students: studentIdList.students,
    });
  };

  handleContinue = (studentIdList: any, csvName: string) => {
    this.addListToSelection(studentIdList, csvName);
    this.props.onContinue();
  };

  handleBack = () => {
    this.props.clearSelection();
    this.setState({
      csvName: null,
      studentIdListUuid: null,
    });
  };

  handleOrgSelection = (selectedOrganizationUuid: string) => {
    this.setState({ selectedOrganizationUuid });
  };

  handleUploadSuccess = (data: { studentIdListUuid: string; csvName: string }) => {
    this.setState({ studentIdListUuid: data.studentIdListUuid, csvName: data.csvName });
  };

  render() {
    if (this.props.loading) {
      return <CenteredLoadingIndicator />;
    }

    const { showNullState, studentIdListUuid, csvName, selectedOrganizationUuid } = this.state;

    if (showNullState) {
      return (
        <TargetByStudentIdNull
          data-test="null-page"
          onContinue={this.hideNullState}
          onMount={() => this.props.onPageChange('upload_list_null')}
        />
      );
    }

    return studentIdListUuid && csvName ? (
      <TargetByStudentIdSelectPage
        data-test="select-page"
        onContinue={this.handleContinue}
        onBack={this.handleBack}
        orgUuid={selectedOrganizationUuid}
        studentIdListUuid={studentIdListUuid}
        csvName={csvName}
        onMount={() => this.props.onPageChange('list_of_uploaded_users')}
      />
    ) : (
      <TargetByStudentIdUploadPage
        data-test="upload-page"
        organizations={this.props.organizations}
        onUploadSuccess={this.handleUploadSuccess}
        onOrgSelection={this.handleOrgSelection}
        selectedOrganizationUuid={this.state.selectedOrganizationUuid}
        onMount={() => this.props.onPageChange('upload_list')}
      />
    );
  }
}

export default TargetByStudentIdPanel;
